import React from "react";

import { Icon } from "@chakra-ui/react";
import {
  MdPerson,
  MdGroup,
  MdHome,
  MdNoCell,
  MdBallot,
  MdNotifications,
  MdFolderShared,
  MdArchive,
  MdOutgoingMail,
  MdMarkEmailUnread,
  MdListAlt,
  MdBadge
} from "react-icons/md";

// Admin Imports
import MainDashboard from "views/main/default";
import ProfileSetting from "views/main/profilesetting";
import ManageAdmin from "views/main/manageadmin";
import NotifInfoAdmin from "views/main/notifinfoadmin";
import ShareDoc from "views/main/sharedoc";
import SukelAdmin from "views/main/sukeladmin";
import SumaAdmin from "views/main/sumaadmin";
import ArchiveDoc from "views/main/archivedoc";
import BmnAdmin from "views/main/bmnadmin";

// TU & Non TU Imports
import MainDashboardTu from "views/main/defaulttu";
import MainDashboardNonTu from "views/main/defaultnontu";
import NotifInfo from "views/main/notifinfo";
import Sukel from "views/main/sukel";
import Suma from "views/main/suma";
import Bmn from "views/main/bmn";

// Up Imports
import KepegawaianUp from "views/main/kepegawaianup";
import Kepegawaian from "views/main/kepegawaian";

// Keu & Petugas Imports
import MainDashboardPetugas from "views/main/defaultpetugas";
import SuketPengKeu from "views/main/suketpengkeu";
import SuketPeng from "views/main/suketpeng";

// Auth Import
import SignInCentered from "views/auth/signIn";

export const routesAdmin = [
  {
    name: "Beranda",
    layout: "/main",
    path: "/default",
    icon: <Icon as={MdHome} width='20px' height='20px' color='inherit' />,
    component: MainDashboard,
  },
  {
    name: "Profil & Pengaturan",
    layout: "/main",
    path: "/profilesetting",
    icon: <Icon as={MdPerson} width='20px' height='20px' color='inherit' />,
    component: ProfileSetting,
    secondary: true,
  },
  {
    name: "Notifikasi & Informasi",
    layout: "/main",
    path: "/notifinfo",
    icon: <Icon as={MdNotifications} width='20px' height='20px' color='inherit' />,
    component: NotifInfoAdmin,
  },
  {
    name: "Kelola Pengguna",
    layout: "/main",
    path: "/manageadmin",
    icon: <Icon as={MdGroup} width='20px' height='20px' color='inherit' />,
    component: ManageAdmin,
  },
  {
    name: "Sumber Daya Manusia",
    layout: "/main",
    path: "/sdm",
    icon: <Icon as={MdBadge} width='20px' height='20px' color='inherit' />,
    component: KepegawaianUp,
  },
  {
    name: "Surat Ket. Penghasilan",
    layout: "/main",
    path: "/suketpeng",
    icon: <Icon as={MdListAlt} width='20px' height='20px' color='inherit' />,
    component: SuketPengKeu,
  },
  {
    name: "Disposisi Surat Masuk",
    layout: "/main",
    path: "/suma",
    icon: <Icon as={MdMarkEmailUnread} width='20px' height='20px' color='inherit' />,
    component: SumaAdmin,
  },
  {
    name: "Surat Keluar",
    layout: "/main",
    path: "/sukel",
    icon: <Icon as={MdOutgoingMail} width='20px' height='20px' color='inherit' />,
    component: SukelAdmin,
  },
  {
    name: "Arsip Dokumen",
    layout: "/main",
    path: "/archivedoc",
    icon: <Icon as={MdArchive} width='20px' height='20px' color='inherit' />,
    component: ArchiveDoc,
  },
  {
    name: "Berbagi Dokumen",
    layout: "/main",
    path: "/sharingdoc",
    icon: <Icon as={MdFolderShared} width='20px' height='20px' color='inherit' />,
    component: ShareDoc,
  },
  {
    name: "Barang Milik Negara",
    layout: "/main",
    path: "/bmn",
    icon: <Icon as={MdBallot} width='20px' height='20px' color='inherit' />,
    component: BmnAdmin,
  },
  {
    name: "",
    layout: "/auth",
    path: "/sign-in",
    icon: <Icon as={MdNoCell} width='0px' height='0px' color='inherit' />,
    component: SignInCentered,
  },
];

export const routesTu = [
  {
    name: "Beranda",
    layout: "/main",
    path: "/default",
    icon: <Icon as={MdHome} width='20px' height='20px' color='inherit' />,
    component: MainDashboardTu,
  },
  {
    name: "Profil & Pengaturan",
    layout: "/main",
    path: "/profilesetting",
    icon: <Icon as={MdPerson} width='20px' height='20px' color='inherit' />,
    component: ProfileSetting,
    secondary: true,
  },
  {
    name: "Notifikasi & Informasi",
    layout: "/main",
    path: "/notifinfo",
    icon: <Icon as={MdNotifications} width='20px' height='20px' color='inherit' />,
    component: NotifInfo,
  },
  {
    name: "Disposisi Surat Masuk",
    layout: "/main",
    path: "/suma",
    icon: <Icon as={MdMarkEmailUnread} width='20px' height='20px' color='inherit' />,
    component: SumaAdmin,
  },
  {
    name: "Surat Keluar",
    layout: "/main",
    path: "/sukel",
    icon: <Icon as={MdOutgoingMail} width='20px' height='20px' color='inherit' />,
    component: Sukel,
  },
  {
    name: "Arsip Dokumen",
    layout: "/main",
    path: "/archivedoc",
    icon: <Icon as={MdArchive} width='20px' height='20px' color='inherit' />,
    component: ArchiveDoc,
  },
  {
    name: "Berbagi Dokumen",
    layout: "/main",
    path: "/sharingdoc",
    icon: <Icon as={MdFolderShared} width='20px' height='20px' color='inherit' />,
    component: ShareDoc,
  },
  {
    name: "Barang Milik Negara",
    layout: "/main",
    path: "/bmn",
    icon: <Icon as={MdBallot} width='20px' height='20px' color='inherit' />,
    component: Bmn,
  },
];

export const routesKeu = [
  {
    name: "Beranda",
    layout: "/main",
    path: "/default",
    icon: <Icon as={MdHome} width='20px' height='20px' color='inherit' />,
    component: MainDashboardTu,
  },
  {
    name: "Profil & Pengaturan",
    layout: "/main",
    path: "/profilesetting",
    icon: <Icon as={MdPerson} width='20px' height='20px' color='inherit' />,
    component: ProfileSetting,
    secondary: true,
  },
  {
    name: "Notifikasi & Informasi",
    layout: "/main",
    path: "/notifinfo",
    icon: <Icon as={MdNotifications} width='20px' height='20px' color='inherit' />,
    component: NotifInfoAdmin,
  },
  {
    name: "Surat Ket. Penghasilan",
    layout: "/main",
    path: "/suketpeng",
    icon: <Icon as={MdListAlt} width='20px' height='20px' color='inherit' />,
    component: SuketPengKeu,
  },
  {
    name: "Disposisi Surat Masuk",
    layout: "/main",
    path: "/suma",
    icon: <Icon as={MdMarkEmailUnread} width='20px' height='20px' color='inherit' />,
    component: Suma,
  },
  {
    name: "Surat Keluar",
    layout: "/main",
    path: "/sukel",
    icon: <Icon as={MdOutgoingMail} width='20px' height='20px' color='inherit' />,
    component: Sukel,
  },
  {
    name: "Arsip Dokumen",
    layout: "/main",
    path: "/archivedoc",
    icon: <Icon as={MdArchive} width='20px' height='20px' color='inherit' />,
    component: ArchiveDoc,
  },
  {
    name: "Berbagi Dokumen",
    layout: "/main",
    path: "/sharingdoc",
    icon: <Icon as={MdFolderShared} width='20px' height='20px' color='inherit' />,
    component: ShareDoc,
  },
  {
    name: "Barang Milik Negara",
    layout: "/main",
    path: "/bmn",
    icon: <Icon as={MdBallot} width='20px' height='20px' color='inherit' />,
    component: Bmn,
  },
];

export const routesUm = [
  {
    name: "Beranda",
    layout: "/main",
    path: "/default",
    icon: <Icon as={MdHome} width='20px' height='20px' color='inherit' />,
    component: MainDashboardTu,
  },
  {
    name: "Profil & Pengaturan",
    layout: "/main",
    path: "/profilesetting",
    icon: <Icon as={MdPerson} width='20px' height='20px' color='inherit' />,
    component: ProfileSetting,
    secondary: true,
  },
  {
    name: "Notifikasi & Informasi",
    layout: "/main",
    path: "/notifinfo",
    icon: <Icon as={MdNotifications} width='20px' height='20px' color='inherit' />,
    component: NotifInfoAdmin,
  },
  {
    name: "Disposisi Surat Masuk",
    layout: "/main",
    path: "/suma",
    icon: <Icon as={MdMarkEmailUnread} width='20px' height='20px' color='inherit' />,
    component: SumaAdmin,
  },
  {
    name: "Surat Keluar",
    layout: "/main",
    path: "/sukel",
    icon: <Icon as={MdOutgoingMail} width='20px' height='20px' color='inherit' />,
    component: SukelAdmin,
  },
  {
    name: "Arsip Dokumen",
    layout: "/main",
    path: "/archivedoc",
    icon: <Icon as={MdArchive} width='20px' height='20px' color='inherit' />,
    component: ArchiveDoc,
  },
  {
    name: "Berbagi Dokumen",
    layout: "/main",
    path: "/sharingdoc",
    icon: <Icon as={MdFolderShared} width='20px' height='20px' color='inherit' />,
    component: ShareDoc,
  },
  {
    name: "Barang Milik Negara",
    layout: "/main",
    path: "/bmn",
    icon: <Icon as={MdBallot} width='20px' height='20px' color='inherit' />,
    component: BmnAdmin,
  },
];

export const routesUp = [
  {
    name: "Beranda",
    layout: "/main",
    path: "/default",
    icon: <Icon as={MdHome} width='20px' height='20px' color='inherit' />,
    component: MainDashboardTu,
  },
  {
    name: "Profil & Pengaturan",
    layout: "/main",
    path: "/profilesetting",
    icon: <Icon as={MdPerson} width='20px' height='20px' color='inherit' />,
    component: ProfileSetting,
    secondary: true,
  },
  {
    name: "Notifikasi & Informasi",
    layout: "/main",
    path: "/notifinfo",
    icon: <Icon as={MdNotifications} width='20px' height='20px' color='inherit' />,
    component: NotifInfo,
  },
  {
    name: "Sumber Daya Manusia",
    layout: "/main",
    path: "/sdm",
    icon: <Icon as={MdBadge} width='20px' height='20px' color='inherit' />,
    component: KepegawaianUp,
  },
  {
    name: "Disposisi Surat Masuk",
    layout: "/main",
    path: "/suma",
    icon: <Icon as={MdMarkEmailUnread} width='20px' height='20px' color='inherit' />,
    component: Suma,
  },
  {
    name: "Surat Keluar",
    layout: "/main",
    path: "/sukel",
    icon: <Icon as={MdOutgoingMail} width='20px' height='20px' color='inherit' />,
    component: Sukel,
  },
  {
    name: "Arsip Dokumen",
    layout: "/main",
    path: "/archivedoc",
    icon: <Icon as={MdArchive} width='20px' height='20px' color='inherit' />,
    component: ArchiveDoc,
  },
  {
    name: "Berbagi Dokumen",
    layout: "/main",
    path: "/sharingdoc",
    icon: <Icon as={MdFolderShared} width='20px' height='20px' color='inherit' />,
    component: ShareDoc,
  },
  {
    name: "Barang Milik Negara",
    layout: "/main",
    path: "/bmn",
    icon: <Icon as={MdBallot} width='20px' height='20px' color='inherit' />,
    component: Bmn,
  },
];

export const routesNonTu = [
  {
    name: "Beranda",
    layout: "/main",
    path: "/default",
    icon: <Icon as={MdHome} width='20px' height='20px' color='inherit' />,
    component: MainDashboardNonTu,
  },
  {
    name: "Profil & Pengaturan",
    layout: "/main",
    path: "/profilesetting",
    icon: <Icon as={MdPerson} width='20px' height='20px' color='inherit' />,
    component: ProfileSetting,
    secondary: true,
  },
  {
    name: "Notifikasi & Informasi",
    layout: "/main",
    path: "/notifinfo",
    icon: <Icon as={MdNotifications} width='20px' height='20px' color='inherit' />,
    component: NotifInfoAdmin,
  },
  {
    name: "Disposisi Surat Masuk",
    layout: "/main",
    path: "/suma",
    icon: <Icon as={MdMarkEmailUnread} width='20px' height='20px' color='inherit' />,
    component: Suma,
  },
  {
    name: "Surat Keluar",
    layout: "/main",
    path: "/sukel",
    icon: <Icon as={MdOutgoingMail} width='20px' height='20px' color='inherit' />,
    component: Sukel,
  },
  {
    name: "Arsip Dokumen",
    layout: "/main",
    path: "/archivedoc",
    icon: <Icon as={MdArchive} width='20px' height='20px' color='inherit' />,
    component: ArchiveDoc,
  },
  {
    name: "Berbagi Dokumen",
    layout: "/main",
    path: "/sharingdoc",
    icon: <Icon as={MdFolderShared} width='20px' height='20px' color='inherit' />,
    component: ShareDoc,
  },
  {
    name: "Barang Milik Negara",
    layout: "/main",
    path: "/bmn",
    icon: <Icon as={MdBallot} width='20px' height='20px' color='inherit' />,
    component: Bmn,
  },
];

export const routesPetugas = [
  {
    name: "Beranda",
    layout: "/main",
    path: "/default",
    icon: <Icon as={MdHome} width='20px' height='20px' color='inherit' />,
    component: MainDashboardPetugas,
  },
  {
    name: "Profil & Pengaturan",
    layout: "/main",
    path: "/profilesetting",
    icon: <Icon as={MdPerson} width='20px' height='20px' color='inherit' />,
    component: ProfileSetting,
    secondary: true,
  },
  {
    name: "Notifikasi & Informasi",
    layout: "/main",
    path: "/notifinfo",
    icon: <Icon as={MdNotifications} width='20px' height='20px' color='inherit' />,
    component: NotifInfo,
  },
  {
    name: "Sumber Daya Manusia",
    layout: "/main",
    path: "/sdm",
    icon: <Icon as={MdBadge} width='20px' height='20px' color='inherit' />,
    component: Kepegawaian,
  },
  {
    name: "Surat Ket. Penghasilan",
    layout: "/main",
    path: "/suketpeng",
    icon: <Icon as={MdListAlt} width='20px' height='20px' color='inherit' />,
    component: SuketPeng,
  },
  {
    name: "Berbagi Dokumen",
    layout: "/main",
    path: "/sharingdoc",
    icon: <Icon as={MdFolderShared} width='20px' height='20px' color='inherit' />,
    component: ShareDoc,
  },
];